module.exports = __webpack_public_path__ + "static/media/B2.fccde88e.png";